module.exports = __webpack_public_path__ + "static/media/logo192.ec5859cf.png";